import React from 'react';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';

import { DEFAULT_PAPER_ELEVATION, } from 'common/constants';

type Props = {
    isInShopCart?: boolean,
};

const ProductsItemContainer: React.FC<Props> = ({
    children,
    isInShopCart,
}) => {
    const select = isInShopCart ? { borderColor: 'warning.main', border: 1, } : { borderColor: 'white', border: 1 };

    return (
        <Paper square
            elevation={DEFAULT_PAPER_ELEVATION}>
            <Box pr={2.5}
                pl={0}
                py={4}
                {...select}>
                {children}
            </Box>
        </Paper>
    );
};

export default ProductsItemContainer;
